<template>
<div class="main">
  <waterfall-flow ref="waterfall">
    <template v-for="note in noteList" v-slot:[note.id]>
      <NoteCard :note="note" :key="note.id"></NoteCard>
    </template>
  </waterfall-flow>
</div>
</template>

<script>
import NoteCard from "@/components/NoteCard/index.vue"
import WaterfallFlow from "@/components/Layout/WaterfallFlow.vue"

export default {
  name: "Online",
  components: { WaterfallFlow, NoteCard },
  data() {
    return {
      noteList: [
        { "id": "_ntu98RFU5kl8IhVIsVln", "content": "真是很好看的视频 来自：https://www.bilibili.com/video/BV1Lg411r74j?spm_id_from=333.1007.tianma.1-1-1.click&vd_source=68a9f316a94ae92d0df40de2afcb1258", "tags": { "网址": { "background": "#56b9ba", "color": "#fff", "smart": true }, "哔哩哔哩": { "background": "#fb7299", "color": "#ffffff", "smart": true } }, "background": "#ffffff", "color": "#333333", "top": 333, "type": "", "height": 226, "state": 0, "secret": false, "createAt": 1661702270776, "updateAt": 1661702270776 },
        { "id": "_Ma-XTO2Q0FlJBKIYZoVG", "content": "啦啦啦2", "tags": {}, "background": "#ffffff", "color": "#333333", "top": 0, "type": "", "height": 100, "state": 1, "secret": false, "createAt": 1661698244694, "updateAt": 1661698244694 },
        { "content": "### 可见一斑\n\n比喻见到事物的一小部分也能推知事物的整体。与“以小见大”相似。\n\n> 引用", "background": "#ffffff", "color": "#333333", "top": 668, "tags": {}, "state": 0, "type": "", "height": 213, "id": "pj7guKERjjkvdUIbfmI2A", "createAt": 1657700699005, "updateAt": 1657702740902 },
        { "content": `卷积 (Convolution) 是一种数学运算，它用于在两个函数之间进行运算。在卷积神经网络中，卷积操作通常用于对图像进行处理。\n\n卷积操作的基本思想是，使用一个小的矩阵，称为卷积核（或滤波器），在图像上滑动并与图像的每个部分进行运算。这个运算的结果就是新的图像，称为特征图。\n\n每个卷积核都会学习一个特定的特征，如线条、边缘或斑点等。通过使用多个卷积核，卷积神经网络可以学习出图像的多层次特征。\n\n简单来说，卷积是一种对图像进行特征提取的方法。`, "background": "#ffffff", "color": "#333333", "top": 668, "tags": {}, "state": 0, "type": "", "height": 213, "id": "pj7guKERjjkvdUIbfmI2A-1", "createAt": 1657700699005, "updateAt": 1657702740902 },
      ]
    }
  }
}
</script>

<style scoped>
.main {
  background-color: var(--color-background);

}

</style>
